import React from 'react'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import SectionActions from '../../Redux/SectionRedux'
import FilesActions from '../../Redux/FilesRedux'
import FileUploader from '../FileUploader'

class CreateSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        title_id: '',
        title_en: '',
        status: 'inactive',
        image_file: ''
      },
      file: null,
      uploaded: false
    }

    this.selector = [
      { label: 'Inactive', value: 'inactive' },
      { label: 'Active', value: 'active' }
    ]
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = { ...this.state.form }
      form.image_file = newProps.files.data.upload[0].filename
      this.setState({ form })
    }
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'section-image')
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _inputChange = (event, field) => {
    if (event) event.preventDefault()
    let value
    let form = { ...this.state.form }
    if (field !== 'status') {
      value = event.target.value
      form[field] = value
      this.setState({ form })
    } else {
      if (form.status === 'active') {
        form.status = 'inactive'
      } else {
        form.status = 'active'
      }
      this.setState({ form })
    }
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _submit = (event) => {
    if (event) event.preventDefault()
    let form = { ...this.state.form }
    let data = { form }
    this.props.postSection(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    return (
      <section style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Create new Section</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (ID)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_id} className='form-control' placeholder='Input name' onChange={(event) => this._inputChange(event, 'title_id')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (EN)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_en} className='form-control' placeholder='Input name' onChange={(event) => this._inputChange(event, 'title_en')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Status</label>
            </div>
            <div className='col-9'>
              <Toggle
                checked={this.state.form.status === 'active'}
                name='status'
                onChange={() => this._inputChange(null, 'status')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Banner Image</label>
            </div>
            <div className='col-9'>
              <FileUploader required setting={{ type: 'section-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='submit' className='btn btn-primary'>Submit</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  section: state.section,
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  postSection: (data) => dispatch(SectionActions.postSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateSection)



// WEBPACK FOOTER //
// ./src/Containers/Section/CreateSection.js